// extracted by mini-css-extract-plugin
module.exports = {"main":"PrintButton-module--main--2SmbD"};